import React from 'react'
import FormSection from '../../molecules/FormSection/FormSection'
import PriceList from './PriceList/PriceList'
import Items, { ShoppingCartItem } from './Items/Items'
import * as Styled from './ShoppingCart.styles'
import PaymentForm from './PaymentForm/PaymentForm'
import { InvoiceAddressChoice, PaymentMethod } from './PaymentForm/PaymentForm.types'
import { InputAttrs } from '../../../util/useForm/useForm'
import { Option } from './PaymentForm/IconSelect/IconSelect'
import type { ButtonAttrs } from '../../molecules/NavigationButtons/NavigationButtons'

export type ShoppingCartProps = {
  price: {
    gross: number
    net: number
    tax: number
    taxPercentage: number
  }
  items: ShoppingCartItem[]
  className?: string
  referenceNumber: InputAttrs<string>
  paymentMethod: InputAttrs<PaymentMethod>
  paymentParams: InputAttrs<string>
  invoiceAddressChoice: InputAttrs<InvoiceAddressChoice>
  companyName: InputAttrs<string>
  address: InputAttrs<string>
  postalCode: InputAttrs<string>
  city: InputAttrs<string>
  country: InputAttrs<string>
  showPaymentOptions: boolean
  next: ButtonAttrs
  previous?: ButtonAttrs
  onRemoveProduct?: (id: string) => void
}

const ShoppingCart: React.FunctionComponent<ShoppingCartProps> = ({
  price,
  className,
  items,
  onRemoveProduct,
  previous,
  next,
  showPaymentOptions,
  ...formState
}) => (
  <FormSection title="Je winkelwagen" className={className}>
    <Items items={items} onRemoveItem={onRemoveProduct} />
    <Styled.Divider />
    <PriceList {...price} />
    {showPaymentOptions && <PaymentForm {...formState} />}
    <Styled.NavigationButtons previous={previous} next={next} />
  </FormSection>
)

export default ShoppingCart
